module.exports = __webpack_public_path__ + "img/31.1c96a1d7.jpg";